export const white = "#FFFFFF";
export const black = "#000000";

export const grey = {
  50: "#FAFAFA",
  100: "#F5F5F5",
  200: "#EEEEEE",
  300: "#E0E0E0",
  400: "#BDBDBD",
  500: "#9E9E9E",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  850: "#303030",
  900: "#212121",
};

export const primary = {
  50: "#CBCFED",
  100: "#B8BDE3",
  200: "#9299CE",
  300: "#6B74B9",
  400: "#4550A4",
  500: "#1F2C8F",
  600: "#192372",
  700: "#131A56",
  800: "#0C1239",
  900: "#06091D",
};

export const green = {
  50: "#E6F5EE",
  100: "#CDEADE",
  200: "#9ED6BE",
  300: "#72C29E",
  400: "#4AAE80",
  500: "#20A56D",
  600: "#258A59",
  700: "#21794E",
  800: "#1D6844",
  900: "#19583A",
};

export const yellow = {
  50: "#FFF5E6",
  100: "#FFEBCC",
  200: "#FFD699",
  300: "#FFC266",
  400: "#FFAD33",
  500: "#FF9900",
  600: "#E68A00",
  700: "#CC7A00",
  800: "#B36B00",
  900: "#995C00",
};

export default {
  white,
  grey,
  primary,
  green,
  yellow,
};
